var _defs, _path, _path2, _path3, _path4, _path5, _path6;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWifi(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "wifi_svg__wifi",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 797.19 787.52"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "wifi_svg__gradient_24",
    x1: -524.14,
    y1: 676.32,
    x2: -502.85,
    y2: 676.32,
    gradientTransform: "rotate(180 112.03 395.485)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffe609"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#ffeb31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#fff377"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#fffaaa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#fffec9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffd5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "wifi_svg__gradient_43",
    x1: 729.51,
    y1: 688.97,
    x2: 729.65,
    y2: 688.97,
    gradientTransform: "matrix(1 0 0 -1 0 790.97)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffe000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#ffc700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff7d00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "wifi_svg__gradient_43-2",
    x1: 730.22,
    y1: 680.14,
    x2: 759.34,
    y2: 680.14,
    xlinkHref: "#wifi_svg__gradient_43"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "wifi_svg__gradient_42",
    x1: 708.65,
    y1: 698.83,
    x2: 766.76,
    y2: 698.83,
    gradientTransform: "matrix(1 0 0 -1 0 790.97)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffffd5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#fffec9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#fffaaa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#fff377"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#ffeb31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffe609"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "wifi_svg__gradient_43-3",
    x1: 710.1,
    y1: 702.95,
    x2: 777.25,
    y2: 702.95,
    xlinkHref: "#wifi_svg__gradient_43"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "wifi_svg__gradient_42-2",
    x1: 689.13,
    y1: 722.23,
    x2: 786.09,
    y2: 722.23,
    xlinkHref: "#wifi_svg__gradient_42"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "wifi_svg__gradient_43-4",
    x1: 694.4,
    y1: 725.73,
    x2: 797.19,
    y2: 725.73,
    xlinkHref: "#wifi_svg__gradient_43"
  }), /*#__PURE__*/React.createElement("style", null, "@keyframes flash-ani-01{0%{opacity:0}20%{opacity:1}}@keyframes flash-ani-02{0%{opacity:0}30%{opacity:1}}@keyframes flash-ani-03{0%{opacity:0}40%{opacity:1}}"))), /*#__PURE__*/React.createElement("g", {
    style: {
      animation: "flash-ani-01 3s infinite step-end"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M738.24 102c-5.9-3.3-11.34 0-11.24 6.7s4.9 14.8 10.7 18.2 11.19-.24 11.09-6.94S744 105.25 738.24 102z",
    fill: "url(#wifi_svg__gradient_24)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M759.3 114.35c-1.1-12.5-10.3-18.7-13.2-19.6a6.68 6.68 0 00-5 .3l-11 6.6c1.9-1 4.4-.8 7.3.8 5.9 3.3 10.7 11.4 10.8 18.1 0 3.2-1.1 5.5-2.9 6.7l11.8-7.3c.1.1 2.6-1.5 2.2-5.6z",
    fill: "url(#wifi_svg__gradient_43-2)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      animation: "flash-ani-02 3s infinite step-end"
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M710.3 73.75s-3.2 1.8-.7 8.6c3.6 7.4 7.9 7.8 9.4 7.4s5.9-3.7 9.9-3.5c4.3.2 9.2 2 15.7 7.8a52.56 52.56 0 018.3 10.6c3.1 5.6 4.7 7.7 6.4 8.6s3.9 2.1 5.5.8 5.2-3.05-1.92-14.27c-5-8.6-13.44-23.14-29.54-29.44-12.7-4.9-23.04 3.41-23.04 3.41z",
    fill: "url(#wifi_svg__gradient_42)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M748.4 67.35c-14.4-7.8-22.1-3-22.1-3l-16.2 9.3.2.1s8.8-7.3 21.3-2.4c16.1 6.3 25.7 20.3 30.7 28.9 5.6 8.9 4.7 11.5 3.3 12.9 2.1-1.2 5.7-3.4 7.8-4.6 3-1.8 3.4-1.9 3.7-5.1 1-7.7-14.3-28.3-28.7-36.1z",
    fill: "url(#wifi_svg__gradient_43-3)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      animation: "flash-ani-03 3s infinite step-end"
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M690.6 40.75s-3.8 2.7.8 10.2a14.54 14.54 0 003.8 4.2c2.5 1.6 4 1.4 5.2.8.8-.4 1.6-.9 2-1.1 1.3-.7 7.4-5.2 18.3-3.7a49.87 49.87 0 0117 6 64.33 64.33 0 016.9 4.4c13.7 10.7 21.4 20.7 25.5 27.6s5.7 10.8 8.8 12.7 4 1.8 5.3.9 3.4-4 .2-9.8-13.1-29.47-36.8-46-40-13.74-41-13.54c-2.92.73-11.6 3.74-16 7.34z",
    fill: "url(#wifi_svg__gradient_42-2)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M795.8 86.75c-3.7-7-7.2-15.1-24.1-33-18.8-18.7-33.8-24.1-44.5-25.6s-16.9 1.3-20.6 3.1c-2.4 1.1-8.4 4.8-12.2 7.1A36.65 36.65 0 01704.7 35c1-.2 16.2-4.5 39.8 12.1s36.6 40.4 39.8 46.1c3 5.4 1.3 8.6 0 9.6 2.1-1.2 10.5-5.9 11.8-7.4 1.5-1.65 1.5-4.85-.3-8.65z",
    fill: "url(#wifi_svg__gradient_43-4)"
  }))));
}

export default SvgWifi;